import { BusinessUnitEmailContactServiceBase } from './business-unit-email-contact.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { BUSINESS_UNIT_EMAIL_CONTACT_POLICE, BusinessUnitEmailContact } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BusinessUnitEmailContactService extends BusinessUnitEmailContactServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findPoliceContactsByBuId(businessUnit: string, reduced: boolean = true): Observable<HateoasMultipleResponseObject<BusinessUnitEmailContact>> {
      var params = appendSerialisedHttpParams(
        {
          buId: businessUnit,
          addrType: BUSINESS_UNIT_EMAIL_CONTACT_POLICE
        }
      );
    
      params = appendSerialisedHttpParams(reduced, 'reduced', params);
  
      return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<BusinessUnitEmailContact>>(this.serviceBaseUrl + '/findByFullFilters', {
        params: params
      }));
    }

}



